// <-- Icon Imports -->
import { Loader2 } from "lucide-react";

const Loading: React.FunctionComponent = () => {
  return (
    <div className="flex h-screen items-center justify-center align-middle">
      <Loader2 className="text-primary animate-spin" width={40} height={40} />
    </div>
  );
};

export { Loading };
